//BuyingProductDetails.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Input, { Textarea } from '../../components/utils/Input';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGifts, faCertificate, faCheck, faClipboardCheck, faFileAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import './ProductListComponent.css';
import Tooltip from '../../components/utils/Tooltip';
import { GenerateOFOrderNumber} from '../../components/GenerateThink5whysCode';

const BuyingProductDetails = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        //Stopping Infinite Loop
    }, [location.state.productId]);
    
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    
    const [userCode, setUserCode] = useState(authState.user.think5whyscode);
    const [productId, setProductId] = useState(location.state.productId);
    const [productData, setProductData] = useState(location.state.productData);
    const [hasPurchased, setHasPurchased] = useState(location.state.hasPurchased);
    const [isFree, setIsFree] = useState(productData.isFree);
    const [isGeneral, setIsGeneral] = useState(productData.isGeneral);
    const [listPrice, setCoverPrice] = useState(productData.listPrice);
    const [offerPrice, setOfferPrice] = useState(productData.offerPrice);
    const [salesPrice, setSalesPrice] = useState(productData.offerPrice);
    const [paymentAmount, setPaymentAmount] = useState(offerPrice);
    const [paymentMode, setPaymentMode] = useState('Online');
    const [insufficientBalance, setInsufficientBalance] = useState(false);
    const [customerName, setCustomerName] = useState(authState.user.name);
    const [purchaseDate, setPurchaseDate] = useState(new Date());
    const [hasReferralCodeClicked, setHasReferralCodeClicked] = useState(false);
    const [hasRedeemGiftClicked, setHasRedeemGiftClicked] = useState(false);
    const [buyingMethod, setBuyingMethod] = useState('Direct');

    const [referralCode, setReferralCode] = useState('');
    const [referralName, setReferralName] = useState('');
    const [referralEmail, setReferralEmail] = useState('');
    const [referralId, setReferralId] = useState(null);
    const [referralUserLevel, setReferralUserLevel] = useState(0);
    const [referralCodeMsg, setReferralCodeMsg] = useState('');
    const [verifyReferralCodeButtonClicked, setVerifyReferralCodeButtonClicked] = useState(false);
    const [mlmAdvisor, setMLMAdvisor] = useState('');
    const [mlmAdvisorCheckMsg, setMLMAdvisorCheckMsg] = useState(null);
    const [userLevel, setUserLevel] = useState(0);
    const [agentName, setAgentName] = useState('');
    const [referralCodeStatus, setReferralCodeStatus] = useState(false);
    const [referralCodeStatusMsg, setReferralCodeStatusMsg] = useState('');
    const [buyingClicked, setBuyingClicked] = useState(false);
    const [walletBuyingClicked, setWalletBuyingClicked] = useState(false);
    const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
    const [walletBalancePoints, setWalletBalancePoints] = useState(0);
    const [walletLastUpdated, setWalletLastUpdated] = useState();
    const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');
    const [paymentStatusMessage, setPaymentStatusMessage] = useState(null);
    const [orderNumber, setOrderNumber] = useState(GenerateOFOrderNumber()); 
    const [error, setError] = useState('');
    const [navigatedFromWalletPayment, setNavigatedFromWalletPayment] = useState(false);
    const [featureStates, setFeatureStates] = useState({});
    const [productDescStates, setProductDescStates] = useState({});
    const allowedSelfReferrerCodes = ['TU243AM5850150', 'TU243BM5850150', 'TU2454M5850150'];
    const [referrerHasPurchased, setReferrerHasPurchased] = useState(false);
    const [referrerHasPurchasedMsg, setReferrerHasPurchasedMsg] = useState('');

    const [resellerId, setResellerId] = useState(authState.user._id);
    const [resellerCode, setResellerCode] = useState(authState.user.think5whyscode);
    const [resellerName, setResellerName] = useState(authState.user.name);
    const [resellerMargin, setResellerMargin] = useState(0);
    
    const handleRedeemNow = () => {
        setNavigatedFromRedeemNow(1);
    };

    const walletPaymentClicked = () => {
        setNavigatedFromWalletPayment(1);
    };

    useEffect(() => {
        if (navigatedFromWalletPayment) {
            // console.log("setNavigatedFromWalletPayment before setting from useEffect", navigatedFromWalletPayment);
            saveBuyNow();
        }
    }, [navigatedFromWalletPayment]);

    const handleRechargeWallet = () => {
        navigate('/wallet-topup', 
            // { state: { productData: productData, paymentAmount: paymentAmount, userId: authState.user._id, userName: authState.user.name, rechargeAmount: amount } 
            { state: { title: productData.productName, paymentAmount: paymentAmount - walletBalanceAmount, userId: authState.user._id, userName: authState.user.name, rechargeAmount: paymentAmount - walletBalanceAmount } 
        });
    };

    // const calculateResellerPaymentAmount = (wp) => {
    //     setPaymentAmount(Number(wp) + Number(resellerMargin));
    // };

    const [errorMessage, setErrorMessage] = useState('');
    const [calculateResellerPaymentAmountClicked, setCalculateResellerPaymentAmountClicked] = useState(false);

    const calculateResellerPaymentAmount = (wp) => {
        if (resellerMargin >= 0 && resellerMargin <= productData.offerPrice - productData.wholesalePrice) {
        setPaymentAmount(Number(wp) + Number(resellerMargin));
        setCalculateResellerPaymentAmountClicked(true);
        setErrorMessage(''); 
        } else {
        setErrorMessage(`Reseller margin must be between 0 and ${productData.offerPrice - productData.wholesalePrice}`);
        }
    };

    const saveBuyNow = async () => {
        const currentDate = new Date();
        const navigatedFromWalletPayment = 1;
        const requestData = {
            userId: userId,
            userCode: userCode,
            userName: userName,
            userLevel: referralUserLevel + 1,
            advisorId: referralId,
            advisorCode: referralCode,
            advisorName: referralName,
            advisorLevel: referralUserLevel,
            productId: productData._id,
            productCode: productData.productCode,
            productName: productData.productName,
            productDesc: productData.productDesc,
            hsnCode: productData.hsnCode,
            unit: productData.unit,
            isGeneral: productData.isGeneral,
            productImage: '',
            purchaseDate: purchaseDate,
            salesDate: purchaseDate,
            isActive: true,
            isDeleted: false,
            isChildren: productData.isChildren,
            isCombo: productData.isCombo,
            comboName: productData.comboName,
            brandName: productData.brandName,
            sellerName: productData.sellerName,
            sellerAddress: productData.sellerAddress,
            sellerContact: productData.sellerContact,
            sellerGST: productData.sellerGST,
            manufacturerName: productData.manufacturerName,
            category: productData.category,
            subCategory: productData.subCategory,
            remarks: productData.isGeneral === false ? "MLM" : "No MLM",
            productFeature: productData.productFeature,
            displayIndex: productData.displayIndex,
            wholesalePrice: productData.wholesalePrice,
            listPrice: productData.listPrice,
            offerPrice: productData.offerPrice,
            qty: 1,
            salesPrice: salesPrice,
            taxRate: productData.taxRate,
            receiptNumber: orderNumber,
            invoiceNumber: orderNumber,
            paymentAmount: paymentAmount,
            paymentMode: paymentMode,
            paymentDate: new Date(),
            transactionId: "",
            paymentRemarks: "",
            navigatedFromWalletPayment: navigatedFromWalletPayment,
            navigatedFromOnlinePayment: false,
            isCombo: productData.isCombo,
            splRemarks: "Referral Sales",
            MLMCommissionStructure: productData.MLMCommissionStructure,
            MLMCommission: 0,
            buyingMethod: buyingMethod,
            isBeSure: productData.isBeSure,
            isPacketPulse: productData.isPacketPulse,
            isSubscription: productData.isSubscription,
            isRenewable: productData.isRenewable,
            isBOGO: productData.isBOGO,
            isCRM: productData.isCRM,
            isT5WSubs: productData.isT5WSubs,
            subsValidityDays: productData.subsValidityDays,
            subsApplied: false,
            subsStartDate: null,
            subsEndDate: null,
            subsRemarks: productData.subsRemarks,
            subsApplyDate: null,
            isT5WPageTopup: productData.isT5WPageTopup,
            pageTopupCount:productData.pageTopupCount,
            pageTopupApplied: false,
            pageTopupApplyDate: null,
            pageTopupRemarks: productData.productName,
            mlmPlan: productData.mlmPlan,
            isCOD: productData.isCOD,
            resellerMargin: resellerMargin,
            resellerId: resellerId,
            resellerCode: resellerCode,
            resellerName: resellerName,
            isGSTBill: productData.isGSTBill,
        };
        // console.log("SaveBuyNow(): ",requestData);
        try {
            const config = { 
                url: `/myproducts`, 
                method: "post", 
                data: { productData: requestData, isMLMReferral: referralCodeStatus }, 
                headers: { Authorization: authState.token } 
            };
            await fetchData(config);
            navigate('/orderflow-myproducts');
        } catch (error) {
            console.error('An error occurred while fetching data:', error);
        }
    };

    const referralCodeValidationClicked = (referralCode, productIdForReferral) => {
        if (/^TU[a-zA-Z0-9]{12}$/.test(referralCode)) {
            if (userCode === referralCode && !allowedSelfReferrerCodes.includes(referralCode)) {
                setError("You cannot be self referrer. Please use a different valid referral code than yours.");
            } else {
                fetchReferralCodeForProduct(referralCode, productIdForReferral);
                // console.log("Fetching Referrer Code for Product",productIdForReferral);
            }
        } else {
            setError('Please enter a valid 14-character Think5Whys DigiLearn Ambassador Referral ID starting with TU.');
        }
    };
    
    const handleReferralCodeValidation = () => {
        setVerifyReferralCodeButtonClicked(true);
    };

    const fetchReferralCode = useCallback((referralCode) => {
        // console.log("referralCode for API call ", referralCode);
        const config = {
            url: "/auth/verifyreferralcode",
            method: "post",
            headers: { Authorization: authState.token },
            data: { think5whyscode: referralCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("referralCode found ", response);
                    setReferralName(response.t5wcode.name);
                    setReferralEmail(response.t5wcode.email);
                    setReferralId(response.t5wcode._id);
                    setReferralCodeStatus(true);
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} found! 😊`);
                } else {
                    // console.log("referralCode Not found");
                    setReferralCodeStatus(false);
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔`);
                }
            })
            .catch(error => {
                // console.log("referralCode Not found!");
                setReferralCodeStatus(false);
                setReferralCodeStatusMsg(`Referral Code ${referralCode} not found! 😔`);
            });
    }, [fetchData, setReferralCodeStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchReferralCode]);

    const fetchReferralCodeForProduct = useCallback((referralCode, productIdForReferral) => {
        // console.log("referralCode for API call ", referralCode, "usercode: ", userCode ," for productId ", productIdForReferral);
        if (allowedSelfReferrerCodes.includes(referralCode)) {
            // console.log("allowed self referralCode for API call ", referralCode, " for productId ", productIdForReferral);
            setAllowedSelfReferralForProduct(referralCode, productIdForReferral);
            // return;
        }
        const config = {
            url: "/myproducts/checkreferral",
            method: "post",
            headers: { Authorization: authState.token },
            data: { advisorCode: referralCode, productId: productIdForReferral }
        };
        // console.log("Request Payload for check referral code in Buying Product in MLM: ", { referralCode, productIdForReferral }); 

        fetchData(config)
            .then(response => {
                if (response && response.status) {
                    // console.log("referralCode found ", response);
                    setReferralCodeStatus(true);
                    setReferralId(response.referralUser.userId);
                    setReferralName(response.referralUser.userName);
                    setReferralUserLevel(response.referralUser.userLevel);
                    // console.log("response.referralUser.userLevel ", response.referralUser.userLevel);
                    setSalesPrice(offerPrice);
                    setBuyingMethod("MLM");
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} for ${productData.productName} found! 😊`);
                 
                    const userCodeInChart = referralCode;
                    const productIdChart = productIdForReferral;

                    // console.log("Referrer Code to be searched as userCode in MLM Chart: ",referralCode);
                    // console.log("Product Id to be searched in MLM Chart: ",productIdChart);
                    // console.log("MLM Advisor from Chart: ", mlmAdvisor);
                } else {
                    // console.log("referralCode Not found", response);
                    if (allowedSelfReferrerCodes.includes(referralCode)) {
                        // console.log("referralCode not found but setting for allowed self referrer", response);
                        setReferralCodeStatus(true);
                        setReferralId(userId);
                        setReferralName(userName);
                        setReferralUserLevel(0);
                        setSalesPrice(offerPrice);
                        setBuyingMethod("MLM");
                        setReferralCodeStatusMsg(`Self Referral ${referralCode}! 😊`);
                        const userCodeInChart = referralCode;
                        const productIdChart = productId;
                        // console.log("Setting Self Referrer Code in MLM Chart: ",referralCode);
                        // console.log("Product Id to be searched in MLM Chart: ",productIdChart);
                    } else {
                        setReferralCodeStatus(false);
                        setReferralCodeStatusMsg(`Referral Code ${referralCode} for ${productData.productName} not found! 😔 Make sure the Referral Code is valid and the Referrer has purchased this Product.`);
                    }
                }
            })
            .catch(error => {
                // console.log("referralCode Not found!", referralCode);
                if (allowedSelfReferrerCodes.includes(referralCode)) {
                    // console.log("referralCode not found but setting for allowed self referrer");
                    setReferralCodeStatus(true);
                    setReferralId(userId);
                    setReferralName(userName);
                    setReferralUserLevel(0);
                    setSalesPrice(offerPrice);
                    setBuyingMethod("MLM");
                    setReferralCodeStatusMsg(`Self Referral ${referralCode}! 😊`);
                    const userCodeInChart = referralCode;
                    const productIdChart = productId;
                    // console.log("Setting Self Referrer Code in MLM Chart: ",referralCode);
                    // console.log("Product Id to be searched in MLM Chart: ",productIdChart);
                } else {
                    setReferralCodeStatus(false);
                    setReferralCodeStatusMsg(`Referral Code ${referralCode} for ${productData.productName} not found! 😔 Make sure the Referral Code is valid and the Referrer has purchased this Product.`);
                }
            });
    }, [fetchData, setReferralCodeStatus]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchReferralCodeForProduct]);

    const setAllowedSelfReferralForProduct = useCallback((referralCode, productIdForReferral) => {
        if (referralCode === 'TU243AM5850150') {
            setReferralCodeStatus(true);
            setReferralId("65ed7e599dc48d2b0999f35d");
            setReferralName("Srishti Sinha");
            setReferralUserLevel(1);
            setSalesPrice(offerPrice);
            setBuyingMethod("MLM");
            setReferralCodeStatusMsg(`Setting Self Referral Code ${referralCode} for ${productData.productName}! 😊`);
        } else if (referralCode === 'TU243BM5850150') {
            setReferralCodeStatus(true);
            setReferralId("65eeb0b362e8020c10acdb1a");
            setReferralName("Sanjeev Kumar");
            setReferralUserLevel(1);
            setSalesPrice(offerPrice);
            setBuyingMethod("MLM");
            setReferralCodeStatusMsg(`Setting Self Referral Code ${referralCode} for ${productData.productName}! 😊`);
        
        } else if (referralCode === 'TU2454M5850150') {
            setReferralCodeStatus(true);
            setReferralId("663623dab68a638b3b6a4248");
            setReferralName("Babita Sinha");
            setReferralUserLevel(1);
            setSalesPrice(offerPrice);
            setBuyingMethod("MLM");
            setReferralCodeStatusMsg(`Setting Self Referral Code ${referralCode} for ${productData.productName}! 😊`);
        } else {
            // console.log("Not In List");
        }
    }, [setReferralCodeStatus]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, setAllowedSelfReferralForProduct]);

    const fetchOrderFlowMLMChart = useCallback(() => {
        // console.log("fetchOrderFlowMLMChart for API call ", referralCode, " for productId ", productId);
        const config = {
            url: "/orderflowmlmchart/advisorasuser",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userCode: referralCode, productId: productId }
        };
        // console.log("fetchOrderFlowMLMChart ", config);

        fetchData(config)
            .then(response => {
                // console.log("MLM API Response ", response);

                if (response && response.status) {
                    // console.log("MLM record found!!!!!!!!!! ", response);
                    setMLMAdvisor(response.data.mlmAdvisor);
                } else {
                    // console.log("MLM record Not found!???!!!! Response Else ");
                    setMLMAdvisorCheckMsg(`Referral Code ${referralCode} for ${productData.productName} not found in referral tree! 😔 Make sure the Referral Code is valid.`);
                }
            })
            .catch(error => {
                // console.log("MLM record Not found!???!!!!  Catch Block");
                setMLMAdvisorCheckMsg(`Referral Code ${referralCode} for ${productData.productName} not found in referral tree! 😔 Make sure the Referral Code is valid.`);
            });
    }, [fetchData, setMLMAdvisor]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
    }, [authState.isLoggedIn, fetchOrderFlowMLMChart]);

    //WalletBalance
    const fetchWalletBalance = useCallback(() => {
        const config = {
            url: "/walletbalance",
            method: "get",
            headers: { Authorization: authState.token }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Wallet Balance Response:", response);
                if (response) {
                    // console.log("Wallet Balance Response in array:", response);
                    setWalletBalanceAmount(response.balanceAmount);
                    setWalletBalancePoints(response.balancePoints);
                    setWalletLastUpdated(response.lastTransactionDate);
                    setWalletLastUpdatedRemarks(response.remarks);
                } else {
                    console.error("Invalid response format: Wallet not found in response");
                    setWalletBalanceAmount(0);
                    setWalletBalancePoints(0);
                    setWalletLastUpdated(null);
                    setWalletLastUpdatedRemarks('');
                }
            })
            .catch(error => {
                console.error("Error fetching wallet master:", error);
                setWalletBalanceAmount(0);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchWalletBalance();
    }, [authState.isLoggedIn, fetchWalletBalance]);

    const toggleFeatures = (productId) => {
        setFeatureStates((prevState) => ({
            ...prevState,
            [productId]: !prevState[productId]
        }));
    };

    const toggleProductDesc = (productId) => {
        setProductDescStates((prevState) => ({
            ...prevState,
            [productId]: !prevState[productId]
        }));
    };

    return (
        <div className='bg-black'>
            <div className="min-h-screen py-2 bg-black">
                <h2 className='text-2xl font-bold text-white text-center mb-4'>Product Details</h2>
                <div className="product-item bg-black flex justify-center items-center">
                    <div className="mt-2 flex justify-center w-full">
                        <img 
                            src={ `/api/downloads/orderflow/products/${productData.productCode}.png` }
                            alt={"No Image " + productData.productName} 
                            className="flex justify-center items-center"
                        />
                    </div>
                    <div className="details-container mt-2 mb-4">
                        <h2 className={`product-title ${productData.isReseller ? 'text-blue-700' : 'text-orange-400'}`}>
                            {productData.productName}
                        </h2>
                        <p className="product-author text-blue-500">by {productData.brandName}</p>
                        <p className="product-author text-blue-500">
                            <del className='text-red-500'>Price ₹{productData.listPrice.toFixed(2)}</del>
                            <strong className='text-green-500'> Buy Now @ ₹{productData.offerPrice.toFixed(2)}</strong>
                        </p>
                        {productData.isReseller && (
                            <p className="product-author text-blue-500">Available through Reseller on Wholesale Price</p>
                        )}
                    </div>
                   
                    <div className="details-container">
                        <h2 className={`${productData.isAvailable === true ? 'text-blue-800' : 'text-yellow-300'} text-xl mt-2`}>
                            {productData.isAvailable === true ? "Available" : "Currently Unavailable"}
                        </h2>
                    </div>
                    {productData.productFeature !== "" && (
                        <>
                            <div className="details-container flex justify-center">
                                <button
                                    onClick={() => toggleFeatures(productData._id)}
                                    style={{ maxWidth: '150px' }}
                                    className="show-button"
                                >
                                    {featureStates[productData._id] ? 'Hide Features' : 'Show Features'}
                                </button>
                            </div>
                            {featureStates[productData._id] && (
                                <div className="feature-container text-white mb-4" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: productData.productFeatures }} />
                            )}
                        </>
                    )}
                    {productData.productDesc !== "" && (
                        <>
                            <div className="details-container flex justify-center">
                                <button
                                    onClick={() => toggleProductDesc(productData._id)}
                                    style={{ maxWidth: '250px' }}
                                    className="show-button"
                                >
                                    {productDescStates[productData._id] ? 'Hide Product Details' : 'Show Product Details'}
                                </button>
                            </div>
                            {productDescStates[productData._id] && (
                                <div className="details-container mt-1 mb-4">
                                    <p className="product-author text-blue-500 text-xl mt-1">Product Description:</p>
                                    <div className="feature-container text-white" style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: productData.productDesc }} />
                                </div>
                            )}
                        </>
                    )}
                    {productData.remarks !== "" && (
                        <div className="details-container mt-1 mb-4">
                            <p className="product-author text-blue-500 text-xl mt-1">{productData.remarks}</p>
                        </div>
                    )}
                    {productData.isAvailable === true && productData.isGeneral === false && (
                        <>
                            <div className="details-container mt-2">
                                <h2 className='text-lime-500 text-lg mb-4'><FontAwesomeIcon icon={faStar} className="text-blue-500 text-4xl" /></h2>
                            </div>
    
                            <div className="details-container mt-2">
                                {!hasPurchased && (
                                    <h2 className='text-purple-700 text-xl'><strong>Purchase this and earn from referrals!!</strong></h2>
                                )}
                            </div>
                            <div className='flex flex-col'>
                                <p className='text-black'>
                                    Use Referral Code to Buy Product or Services from OrderFlow@think5Whys and Enroll Yourself Under Think5Whys Referral Earning Program
                                </p>
                                <p className='text-blue-600'>Ask Referral Code from the Referrer. The code could be found under Home{'->'}Profile{'->'}My Think5Whys Code</p>
                                <p className='text-blue-600'>If you are referring then get your Referral Code from Home{'->'}Profile{'->'}My Think5Whys Code</p>
                                <div className="details-container w-full mx-auto text-black bg-slate-400 rounded-lg shadow-lg mb-4 mt-4 py-2">
                                    <div className='mt-4 flex flex-col text-wrap justify-center'>
                                        <p className='text-yellow-400'>Input 14 Characters Alphanumeric Referrer ID (eg TU243BM5850150):</p>
                                        <p className='text-white'>Ask your referrer to provide their Referrer Code from Home {'->'} Profile {'->'} My Think5Whys Code</p>
                                        <p className='text-yellow-400'>To apply their Referrer Code they must have purchase this item using "I have my DigiLearn Ambassador Referral Code"</p>
                                    </div>
                                    <div className='mb-4 flex text-wrap justify-center'>
                                        <p className='text-white'>Your User Code is {userCode}</p>
                                    </div>
                                    <div className="mb-4 flex justify-center">
                                        <input
                                            type="text"
                                            name="referralCode"
                                            id="referralCode"
                                            value={referralCode}
                                            placeholder="Input Referrer ID"
                                            onChange={(e) => setReferralCode(e.target.value)}
                                            className="h-12 text-center p-2 border border-gray-300"
                                        />
                                    </div>
                                    <div className="mb-4 flex justify-center">
                                        {error && <p className="text-red-800 justify-left text-lg">{error}</p>}
                                    </div>
                                    <div className='mb-4 flex flex-col items-center'>
                                        <p className={referralCodeStatus ? "text-green-800 text-xl" : "text-red-600 text-lg"}>
                                            {referralCodeStatusMsg}
                                        </p>
                                        <button
                                            type="button"
                                            className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={() => {
                                                referralCodeValidationClicked(referralCode, productId);
                                                handleReferralCodeValidation();
                                            }}
                                            disabled={referralCodeStatus}
                                        >
                                            {referralCodeStatus ? "Referrer ID Validated" : "Validate Referrer ID"}
                                        </button>
                                        {referralCodeStatus && (
                                            <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                                {referralCode && (
                                                    <>
                                                        <div className="flex justify-center">
                                                            <p className="text-white text-lg">Your Referrer Name: <strong className="text-yellow-300 text-lg">{referralName}</strong></p>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="mt-6 mb-2">
                                                    <div className="mb-4 text-lg text-white">
                                                        <p>Price to pay: <span className='text-yellow-300'>₹{paymentAmount.toFixed(2)}</span></p>
                                                        <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                                        {paymentAmount > walletBalanceAmount ? (
                                                            <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                                        ) : (
                                                            <p className="text-white">
                                                                After payment your Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                                {walletBalanceAmount < productData.offerPrice && (
                                                    <div className='mb-4 flex text-wrap justify-center'>
                                                        {/* <button
                                                            type="button"
                                                            className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                            onClick={() => handleRechargeWallet(productData.offerPrice + walletBalanceAmount)}
                                                            >
                                                            Recharge Think5Whys Purse / Wallet
                                                        </button> */}
                                                        <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>

                                                    </div>
                                                )}
                                                {walletBalanceAmount >= productData.offerPrice && (
                                                    <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-gray-600 text-white max-w-md mx-auto my-4">
                                                        <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                        <div className="space-y-2 text-gray-700">
                                                        <p><strong>Order Number:</strong> {orderNumber}</p>
                                                        <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                        <p><strong>Customer Name:</strong> {customerName}</p>
                                                        <p><strong>Customer Address:</strong> Online Product</p>
                                                        <p><strong>Item:</strong> {productData.productName}</p>
                                                        <p><strong>Item Description:</strong> {productData.productName}</p>
                                                        <p className="text-lg font-bold text-yellow-200"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                        <p className="text-lg font-bold text-yellow-200"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                        <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                        </div>
                                                        <div className="flex justify-center mt-6">
                                                        <button
                                                            type="button"
                                                            className="bg-green-800 text-white py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                            onClick={walletPaymentClicked}
                                                        >
                                                            Confirm Now To Buy. Your Think5Whys Wallet Will Be Charged.
                                                        </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {productData.isAvailable === true && productData.isGeneral === true && (
                        <>
                        <div>
                            <div className="details-container w-full mx-auto text-white bg-black border border-blue-400 p-4 rounded-lg shadow-lg mb-4 mt-4 py-2">
                                <div className='mb-4 flex flex-col items-center'>
                                    { productData.isReseller === true && (
                                        <>
                                        <p className='text-white'>Wholesale Price: {productData.wholesalePrice.toFixed(2)}</p>
                                        <p className='text-white'>Add Your Margin (Maximum is: {productData.offerPrice-productData.wholesalePrice} )</p>
                                        <input
                                            type="number"
                                            name="resellerMargin"
                                            id="resellerMargin"
                                            value={resellerMargin}
                                            min={0}
                                            max={productData.offerPrice-productData.wholesalePrice}
                                            onChange={(e) => setResellerMargin(e.target.value)}
                                            className="h-12 text-center p-2 border border-gray-300"
                                            style={{width: '150px'}}
                                        />
                                        <button
                                            type="button"
                                            className="block mt-2 mb-2 w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={() => calculateResellerPaymentAmount(productData.wholesalePrice)}
                                            >
                                            Sales Price
                                        </button>
                                        {errorMessage && (
                                            <div className="text-red-600 mt-2">{errorMessage}</div>
                                        )}
                                        </>
                                    )}
                                    <div className="details-container w-full sm:w-11/12 md:w-10/12 lg:w-8/12 xl:w-7/12 mx-auto text-black bg-slate-400 rounded-lg shadow-lg p-4 mb-2">
                                        <div className="mb-2 text-lg text-white">
                                            <p>Price to pay: <span className='text-yellow-300'>₹{paymentAmount}</span></p>
                                            <p>Think5Whys Purse / Wallet Balance: <span className='text-yellow-300'>₹{walletBalanceAmount.toFixed(2)}</span></p>
                                            {paymentAmount > walletBalanceAmount ? (
                                                <p className="text-red-500">Insufficient Balance by: ₹{(paymentAmount - walletBalanceAmount).toFixed(2)}</p>
                                            ) : (
                                                <p className="text-white">
                                                    After payment your Think5Whys Purse / Wallet balance will be: <span className='text-yellow-300'>₹{(walletBalanceAmount - paymentAmount).toFixed(2)}</span>
                                                </p>
                                            )}
                                        </div>
                                        {walletBalanceAmount < productData.offerPrice && (
                                            <div className='mb-4 flex text-wrap justify-center'>
                                                {/* <button
                                                    type="button"
                                                    className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                                    onClick={() => handleRechargeWallet(productData.offerPrice + walletBalanceAmount)}
                                                    >
                                                    Make Payment then Return Back to complete the Process
                                                </button> */}
                                                <button type="button" className="block w-full md:w-auto bg-blue-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark" onClick={handleRechargeWallet}>Make Payment then Return Back to complete the Process</button>

                                            </div>
                                        )}
                                        {walletBalanceAmount >= productData.offerPrice && (
                                            <div className="flex flex-col p-6 border-2 border-yellow-400 rounded-lg shadow-lg bg-gray-600 text-white [&_strong]:text-white [&_p]:text-white [&_span]:text-white max-w-md mx-auto my-4">
                                                <h2 className="text-2xl font-semibold text-yellow-200 mb-4 text-center">Order Summary</h2>
                                                <div className="space-y-2 text-white">
                                                <p><strong>Order Number:</strong> {orderNumber}</p>
                                                <p><strong>Order Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                <p><strong>Customer Name:</strong> {customerName}</p>
                                                <p><strong>Customer Address:</strong> Online Product</p>
                                                <p><strong>Item:</strong> {productData.productName}</p>
                                                <p><strong>Item Description:</strong> {productData.productName}</p>
                                                <p className="text-lg font-bold text-yellow-200"><strong>Price To Pay:</strong> ₹{paymentAmount}</p>
                                                <p className="text-lg font-bold text-yellow-200"><strong>Payment Amount:</strong> ₹{paymentAmount}</p>
                                                <p><strong>Payment Date:</strong> {purchaseDate.toLocaleString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' })}</p>
                                                </div>
                                                <div className="flex justify-center mt-6">
                                                <button
                                                    type="button"
                                                    className="bg-green-800 text-white py-2 px-6 rounded-md font-medium hover:bg-green-900 transition duration-300 ease-in-out"
                                                    onClick={walletPaymentClicked}
                                                >
                                                    Confirm Now To Buy. Your Think5Whys Purse / Wallet Will Be Dedcuted.
                                                </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                </div>
            </div>
        </div >
    );
};

export default BuyingProductDetails;
